import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {SharedModule} from '../shared/shared.module'
import {CarouselModule} from 'ngx-owl-carousel-o'
import {FeaturedEventsComponent} from './featured-events.component'


@NgModule({
  declarations: [FeaturedEventsComponent],
  imports: [
    CommonModule,
    SharedModule,
    CarouselModule
  ],
  exports: [FeaturedEventsComponent]
})
export class FeaturedEventsModule {
}
